//src/app/routes/MessageRoutes.tsx
import Conversations from 'app/features/conversations';
import ConversationsList from 'app/features/conversations/Components/ConversationsList';
import Conversation from 'app/features/conversations/Conversation';
import ConversationProvider from 'app/features/conversations/ConversationProvider';
import CreateConversation from 'app/features/conversations/CreateConversation';
import useMediaQueries from 'app/hooks/useMediaQueries';
import { Navigate, Route } from 'react-router-dom';
import ConversationsNotificationsProvider from 'utils/ConversationsNotificationsProvider';

export default function MessagesRoutes() {
  const { md_down: isMobile } = useMediaQueries();

  return (
    <>
      <Route path="messages" element={<Conversations />}>
        <Route
          path=":conversationId"
          element={
            <ConversationsNotificationsProvider>
              <ConversationProvider>
                <Conversation />
              </ConversationProvider>
            </ConversationsNotificationsProvider>
          }
        />

        <Route path="compose" element={<CreateConversation />} />
        {isMobile && <Route path="" element={<ConversationsList />} />}
        {!isMobile && (
          <Route path="" element={<Navigate replace to={'compose'} />} />
        )}
      </Route>
    </>
  );
}
